import Vue from 'vue';

// When the request succeeds
const success = (context, response) => {
  if (response.msg) {
    toastr.success(response.msg);
    context.editAirbnbAccountPwd = {};
    context.closeModal('#edit-airbnb-account');
  }
  context.smallLoading = false;
};

// When the request fails
const failed = (context, error) => {
  if (error && error.response && error.response.data && error.response.data.response &&
      error.response.data.response.client_error_info && error.response.data.response.error_code) {
    if (error.response.data.response.error_code === 420 && error.response.data.response.client_error_info.airlock.flow === 'captcha_flow' && typeof (error.response.data.response.client_error_info.airlock.id) !== 'undefined') {
      context.randomDeviceId = error.response.data.randomDeviceId;
      context.airlockId = error.response.data.response.client_error_info.airlock.id;
      context.changePwdStep = 1;
    } else if (error.response.data.response.error_code === 420 && error.response.data.response.client_error_info.airlock.flow === 'account_ownership_verification_for_login') {
      context.randomDeviceId = error.response.data.randomDeviceId;
      context.airlockId = error.response.data.response.client_error_info.airlock.id;
      context.changePwdStep = 2;
      context.ownerVerification(error.response.data.response);
    } else if (error.response.data.response.error_code === 420 && error.response.data.response.error_message && error.response.data.response.client_error_info.airlock.flow === 'hard_block_message') {
      context.changePwdStep = 0;
      toastr.error(error.response.data.response.error_message);
    }
  } else if (error && error.response && error.response.data && error.response.data.msg) {
    if (error.response.data.msg === 'duplicated') {
      toastr.error(context.$t('account.settings.user_platforms_section.duplicated_airbnb_account'));
    }
    const errorMessages = error.response.data.msg;
    if (typeof errorMessages === 'string') {
      toastr.error(errorMessages);
    } else {
      Object.values(errorMessages).forEach((errorMessage) => {
        toastr.error(errorMessage[0]);
      });
    }
  } else {
    toastr.error(context.$t('rentals.detail.modals.something_went_wrong'));
  }
  context.activeStep = 0;
  context.smallLoading = false;
};

export default (context, data) => Vue.$http.post('/edit-airbnb-account', data).then((response) => {
  if (response) {
    if (response && response.status === 200) {
      success(context, response.data);
    } else {
      failed(context, response);
    }
  }
})
    .catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/account/editAirbnbAccountPwd.js